import {
  adminCountAllMember,
  adminGetComboWorkLocation,
} from "helpers/backend_helpers";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";

const Widgets = () => {
  const [data, setData] = useState(0);
  const [dataLocation, setDataLocation] = useState(0);

  const getData = async () => {
    await adminCountAllMember()
      .then((response: any) => {
        setData(response?.count);
      })
      .catch(() => {});
  };

  const getTotalWorkLocation = async () => {
    await adminGetComboWorkLocation()
      .then((response: any) => {
        setDataLocation(response.length);
      })
      .catch(() => {});
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getTotalWorkLocation();
  }, []);
  return (
    <React.Fragment>
      <Row>
        <Col xl={6} md={6}>
          <Card className="card-animate">
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-truncate mb-0">
                    Karyawan
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-4">
                <div>
                  <h4 className="fs-20 fw-semibold ff-secondary mb-4">
                    <span className="counter-value" data-target="559.25">
                      <CountUp start={0} end={data} duration={4} />
                    </span>
                  </h4>
                  <Link to="/karyawan" className="text-decoration-underline">
                    Detail
                  </Link>
                </div>
                <div className="avatar-sm flex-shrink-0">
                  <span
                    className={"avatar-title rounded fs-3 bg-success-subtle"}
                  >
                    <i className={`text-success bx bx-user-circle`}></i>
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={6} md={6}>
          <Card className="card-animate">
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-truncate mb-0">
                    Lokasi Kerja
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-4">
                <div>
                  <h4 className="fs-20 fw-semibold ff-secondary mb-4">
                    <span className="counter-value" data-target="559.25">
                      <CountUp start={0} end={dataLocation} duration={4} />
                    </span>
                  </h4>
                  <Link
                    to="/lokasi-kerja"
                    className="text-decoration-underline"
                  >
                    Detail
                  </Link>
                </div>
                <div className="avatar-sm flex-shrink-0">
                  <span
                    className={"avatar-title rounded fs-3 bg-primary-subtle"}
                  >
                    <i className={`text-primary ri-map-pin-line`}></i>
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Widgets;
